import PageHero from "../../components/PageHero/PageHero";


import {images} from "../../constants"

import PortfolioShowcase from "../../components/PortfolioShow/PortfolioShowCase";
import { ExperienceSection, Footer, InfiniteMarquee } from "../../container";
import ContentImageSection from "../../components/ContentImageSection/ContentImageSection";
const RevitBim = () => {
  return <>
    <PageHero title="RevitBim Design Portfolio"  bgImage={images.backgroud_img}/>
    <ContentImageSection
    title="Precision BIM & Revit Support, Tailored for You"
    description="
      Gomal Design Studio provides expert Revit BIM outsourcing, delivering accurate plans, elevations, and intelligent 3D models. We combine technical rigor with practical insight to deliver more than just drawings we deliver coordination, clarity, and buildability through detailed schedules, phasing documentation, and intelligent modeling.
      From model setup and existing condition capture to proposed design and construction-ready documentation, we develop meticulously coordinated Revit models that ensure your project doesn’t just get documented—it gets built right."
  highlightWords={["Archilance LLC", "Revit drafting"]}
  image={images.revit_portfolio}
/>
    <div style={{ width: "80%", margin: "3rem auto" }}>
      <hr style={{ border: "none", height: "1px", backgroundColor: "#ddd" }} />
    </div>
    <PortfolioShowcase page="revit-bim" />
    <InfiniteMarquee/>
    <ExperienceSection/>
    <Footer/>
  </>;
};

export default RevitBim;
